import React from 'react';
import { cn } from '../utils/style';

function InvoiceField({name, value, className, hide}) {
    if (hide) return <></>;
    return (
        <div className={cn("transition-all duration-300 ease-in-out hover:bg-white p-3 rounded-2xl bg-gray-50/50 border-0 shadow-none", className)}>
            {name && <div className="uppercase text-[10px] tracking-wider font-bold text-gray-400 mb-1">{name}</div>}
            <div className="text-gray-900 font-semibold text-sm">{value || 'N/A'}</div>
        </div>
    )
}

export default InvoiceField;